import { render } from "./ClientInvoicesModal.vue?vue&type=template&id=6fadeefc&scoped=true"
import script from "./ClientInvoicesModal.vue?vue&type=script&lang=js"
export * from "./ClientInvoicesModal.vue?vue&type=script&lang=js"

import "./ClientInvoicesModal.vue?vue&type=style&index=0&id=6fadeefc&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fadeefc"]])

export default __exports__